import { missingNativeBuild } from "../nativeError";
import { assertPrintFileUri, assertPrintJobName } from "./validate";
function isAvailable() {
  return Promise.resolve(false);
}
function printPdf(fileUri, jobName) {
  assertPrintFileUri(fileUri);
  assertPrintJobName(jobName);
  return Promise.reject(missingNativeBuild("Print.printPdf"));
}
var Print = Object.freeze({
  isAvailable,
  printPdf
});
export {
  Print
};
//# sourceMappingURL=unavailable.js.map
